import { Col, Row, Avatar, Menu, Drawer, Grid } from "antd";
import React, { useEffect, useState } from "react";
import {
  MenuOutlined,
  CloseOutlined,
  HomeOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { StyledLink } from "../styled-components/components";
import { useHistory } from "react-router";
import profile from "../../images/profile.svg";
import { NavLink } from "react-router-dom";
import { Notifications } from "./Header";
import { useSelector } from "react-redux";

const ClientHeader = ({
  getAllNotifications,
  readAllNotifications,
  signOut,
}) => {
  let history = useHistory();
  const [openSliderMenu, setOpenSliderMenu] = useState(false);
  const screens = Grid.useBreakpoint();
  useEffect(() => {
    if (screens.lg || screens.xl || screens.xxl) {
      setOpenSliderMenu(false);
    }
  }, [screens]);
  const { profileImageUrl, userDetails } = useSelector(
    (state) => state.userStore
  );
  const [isImageUrl, setIsImageUrl] = useState(false);
  useEffect(() => {
    if (!profileImageUrl) {
      setIsImageUrl(false);
    } else {
      setIsImageUrl(true);
    }
  }, [profileImageUrl]);
  return (
    <Col xs={{ span: 14 }} xl={{ span: 10 }} xxl={{ span: 8 }}>
      <Col xs={{ span: 0 }} lg={{ span: 24 }}>
        <Row justify="space-between" align="middle">
          <Col>
            <NavLink
              to="/client/dashboard"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-dashboard"
            >
              Dashboard
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/registration/t24"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-t24"
            >
              T24Profile
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/client/new-job"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-createJob"
            >
              Create Job
            </NavLink>
          </Col>
          <Col>
            <NavLink
              to="/client/home"
              activeClassName="selected"
              activeStyle={{
                color: "#1565d8",
                fontSize: "16px",
                fontWeight: "600",
              }}
              data-testid="submit-homePage"
            >
              Jobs
            </NavLink>
          </Col>

          <Col>
            <Row justify="center">
              <Notifications
                readAllNotifications={readAllNotifications}
                getAllNotifications={getAllNotifications}
              />
            </Row>
          </Col>
          <Col>
            <Menu
              mode="horizontal"
              style={{ border: "none", marginLeft: "0px" }}
            >
              <Menu.SubMenu
                title={
                  <Avatar
                    size="large"
                    src={!isImageUrl ? profile : profileImageUrl}
                    data-testid="profile-avatar"
                  ></Avatar>
                }
              >
                <Menu.Item
                  data-testid="submit-profile"
                  onClick={() => history.push("/client/profile/account")}
                >
                  <Col>My Profile</Col>
                </Menu.Item>
                {userDetails && !userDetails.socialLogin ? (
                  <Menu.Item
                    data-testid="submit-changePassword"
                    onClick={() => history.push("/client/profile/security")}
                  >
                    Change Password
                  </Menu.Item>
                ) : null}

                <Menu.Item
                  onClick={() => signOut()}
                  data-testid="submit-signOut"
                >
                  Sign Out
                </Menu.Item>
              </Menu.SubMenu>
            </Menu>
          </Col>
        </Row>
      </Col>
      <Col xs={{ span: 24 }} lg={{ span: 0 }}>
        <Row justify="end">
          <MenuOutlined
            data-testid="openSlider"
            onClick={() => setOpenSliderMenu(true)}
          />
        </Row>
        <Drawer visible={openSliderMenu} closable={false}>
          <Col>
            <Row justify="end">
              <CloseOutlined
                data-testid="closeSlider"
                onClick={() => setOpenSliderMenu(false)}
              />
            </Row>
            <Row style={{ padding: "1vh" }} justify="start" align="middle">
              <HomeOutlined style={{ margin: "1vh" }} />
              <NavLink
                to="/client/home"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-homePage"
              >
                Jobs
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start" align="middle">
              <NavLink
                to="/client/profile/account"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-profile"
              >
                My Profile
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/registration/t24"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-t24"
              >
                T24 Profile
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/client/new-job"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-createJob"
              >
                Create Job
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/client/dashboard"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-dashboard"
              >
                Dashboard
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start">
              <NavLink
                to="/change-password"
                activeClassName="selected"
                activeStyle={{
                  color: "#1565d8",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
                data-testid="submit-changePassword"
              >
                Change Password
              </NavLink>
            </Row>
            <Row style={{ padding: "1vh" }} justify="start" align="middle">
              <LogoutOutlined style={{ margin: "1vh" }} />
              <StyledLink
                onClick={() => signOut()}
                data-testid="submit-signOut"
              >
                Sign Out
              </StyledLink>
            </Row>
          </Col>
        </Drawer>
      </Col>
    </Col>
  );
};
export default ClientHeader;
